import {
  SubscriptionTypes,
  SUBSCRIPTION_TYPES_ERROR,
  SUBSCRIPTION_TYPES_SUCCESS,
  LOADING_SUBSCRIPTION_TYPES,
  SELECT_SUBSCRIPTION_TYPE,
} from '../config/ActionTypes';
import { SubscriptionTypesState } from '../config/types/subscriptionTypes.types';

export const subscriptionTypesInitialState: SubscriptionTypesState = {
  loadingSubscriptionTypes: false,
  subscriptionTypesSuccess: false,
  subscriptionTypes: null,
  selectedSubscriptionType: null,
  subscriptionTypesErrorMessage: null,
};

export function subscriptionTypesReducer(
  state = subscriptionTypesInitialState,
  action: SubscriptionTypes,
): SubscriptionTypesState {
  switch (action.type) {
    case LOADING_SUBSCRIPTION_TYPES:
      return {
        ...state,
        loadingSubscriptionTypes: true,
        subscriptionTypesSuccess: false,
        subscriptionTypes: null,
        selectedSubscriptionType: null,
        subscriptionTypesErrorMessage: null,
      };

    case SUBSCRIPTION_TYPES_SUCCESS:
      return {
        ...state,
        loadingSubscriptionTypes: false,
        subscriptionTypesSuccess: true,
        subscriptionTypes: action.subscriptionTypes,
        selectedSubscriptionType: action.selectedSubscriptionType,
        subscriptionTypesErrorMessage: null,
      };

    case SUBSCRIPTION_TYPES_ERROR:
      return {
        ...state,
        loadingSubscriptionTypes: false,
        subscriptionTypesSuccess: false,
        subscriptionTypesErrorMessage: action.error,
      };

    case SELECT_SUBSCRIPTION_TYPE:
      const selectedSubscriptionType = state.subscriptionTypes?.filter(
        (subscription) => subscription.id.toString() === action.subscriptionTypeId,
      )[0]!;

      return {
        ...state,
        selectedSubscriptionType,
      };

    default:
      return state;
  }
}
